import React, { useEffect } from 'react';
import { useAuth } from 'src/hooks/use-auth';
export const SignOut = () => {
  const { signOut } = useAuth();
  useEffect(() => {
    signOut();
  }, [signOut]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};
